import { jsx as _jsx } from "react/jsx-runtime";
import Star1Selected from './svg/star-1-selected.svg';
import Star1 from './svg/star-1.svg';
import Star2Selected from './svg/star-2-selected.svg';
import Star2 from './svg/star-2.svg';
import Star3Selected from './svg/star-3-selected.svg';
import Star3 from './svg/star-3.svg';
import Star4Selected from './svg/star-4-selected.svg';
import Star4 from './svg/star-4.svg';
import Star5Selected from './svg/star-5-selected.svg';
import Star5 from './svg/star-5.svg';
const ratings = {
    1: { selected: Star1Selected, unselected: Star1 },
    2: { selected: Star2Selected, unselected: Star2 },
    3: { selected: Star3Selected, unselected: Star3 },
    4: { selected: Star4Selected, unselected: Star4 },
    5: { selected: Star5Selected, unselected: Star5 },
};
export const Star = ({ score, isSelected, size, }) => {
    const { selected, unselected } = ratings[score];
    return (_jsx("img", { src: isSelected ? selected : unselected, alt: score.toString(), style: { width: size, height: size } }));
};
